import { createContext, useContext } from "react";

export interface SharedPageState {
    pageGuid?: string;
    recipientGuid?: string;
}

export const defaultSharedPageState: SharedPageState = {
    pageGuid: undefined,
    recipientGuid: undefined,
};

export const SharedPageContext = createContext<SharedPageState>(
    defaultSharedPageState
);

export const useSharedPageContext = () => useContext(SharedPageContext);
